// utils/emailValidation.js (créez ce fichier)
export const validateEmail = (email) => {
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  return regex.test(email);
};

export const getEmailError = (email) => {
  if (!email) return 'L\'email est requis';
  if (!email.includes('@')) return 'L\'email doit contenir @';
  if (!email.includes('.')) return 'L\'email doit contenir un domaine (.com, .fr, etc.)';
  if (email.split('@')[1]?.split('.')[1]?.length < 2) return 'Le domaine est trop court';
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) return 'Format d\'email invalide';
  return null;
};